import type { PaymentSummary } from "../../core/types/order-detail";
import type { Props } from "../../core/types/tsx/components/order-detail/PaymentSummaryCard.types";

const toneClasses: Record<
	NonNullable<PaymentSummary["items"][number]["tone"]>,
	string
> = {
	muted: "text-gray-400",
	negative: "text-red-500",
	positive: "text-green-600",
};

export function PaymentSummaryCard({ payment }: Props) {
	return (
		<aside className='rounded-2xl bg-white p-6 soft-border'>
			<p className='text-sm font-semibold text-gray-700 mb-4'>Resumen de Pago</p>
			<div className='space-y-3 text-sm text-gray-700'>
				{payment.items.map((item) => (
					<div key={item.label} className='flex items-center justify-between'>
						<span
							className={`${item.tone ? toneClasses[item.tone] : "text-gray-600"} ${item.emphasis ? "font-semibold" : "font-normal"}`}
						>
							{item.label}
						</span>
						<span
							className={`${item.emphasis ? "font-semibold" : "font-medium"} ${item.tone ? toneClasses[item.tone] : "text-gray-800"}`}
						>
							{item.amount}
						</span>
					</div>
				))}
			</div>
			<div className='my-4 h-px bg-gray-100' />
			<div className='flex items-center justify-between text-base font-semibold text-gray-900'>
				<span>{payment.totalLabel}</span>
				<span className='text-primary'>{payment.totalAmount}</span>
			</div>
			{payment.actionLabel && (
				<button
					type='button'
					onClick={payment.onAction}
					disabled={payment.actionDisabled || payment.actionLoading}
					className='mt-4 flex w-full cursor-pointer items-center justify-center rounded-full bg-primary px-4 py-2.5 text-sm font-semibold text-white transition hover:bg-primary-hover disabled:cursor-not-allowed'
				>
					{payment.actionLoading ? "Procesando..." : payment.actionLabel}
				</button>
			)}
		</aside>
	);
}

export default PaymentSummaryCard;
